export default "__VITE_ASSET__57aabbfd__"